export default "__VITE_ASSET__BjP70fxm__"